/**
 * Registers the 'studysync' ECharts theme at import time. Every Copilot chart renders with
 * `theme="studysync"`, and the escape hatch's sanitized option inherits it too — so brand
 * consistency is enforced by the renderer, not re-specified per chart.
 *
 * IMPORTANT: import this module for its side effect before any chart mounts (each chart does).
 */
import * as echarts from 'echarts';
import { tokens } from './tokens';

const axis = {
  axisLine: { lineStyle: { color: tokens.surface.border } },
  axisTick: { lineStyle: { color: tokens.surface.border } },
  axisLabel: { color: tokens.text.muted },
  splitLine: { lineStyle: { color: tokens.surface.grid } },
};

echarts.registerTheme('studysync', {
  color: [...tokens.series],
  backgroundColor: 'transparent',
  textStyle: { fontFamily: tokens.fontFamily, color: tokens.text.primary },
  title: {
    textStyle: { fontFamily: tokens.fontFamily, color: tokens.text.primary, fontWeight: 600, fontSize: 16 },
    left: 0,
  },
  legend: { textStyle: { color: tokens.text.muted, fontFamily: tokens.fontFamily } },
  grid: { borderColor: tokens.surface.grid, containLabel: true },
  categoryAxis: axis,
  valueAxis: axis,
  logAxis: axis,
  timeAxis: axis,
  tooltip: {
    backgroundColor: tokens.surface.card,
    borderColor: tokens.surface.border,
    textStyle: { color: tokens.text.primary, fontFamily: tokens.fontFamily },
  },
});

export const STUDYSYNC_THEME = 'studysync';
